import Color from "color";
import validateColor from "validate-color";
export const addColourModifiers = (properties) => Object.fromEntries(Object.entries(properties).flatMap(([key, value]) => {
    if (!value || !validateColor(value))
        return [[key, value]];
    const colour = new Color(value);
    const opacityValues = generateOpacityValues(colour, key);
    const contrastingTextValue = generateContrastingTextValue(colour, key, properties);
    const mutedValues = generateMutedValues(colour, key);
    return [[key, value], ...opacityValues, ...mutedValues, contrastingTextValue];
}));
const generateMutedValues = (color, key) => {
    const NEUTRAL_COLOUR = new Color("#EFEFEF");
    return [[`${key}--muted`, color.mix(NEUTRAL_COLOUR, 0.96).toString()]];
};
const generateOpacityValues = (colour, key) => {
    const opacities = [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9];
    return opacities.map((alpha) => [
        `${key}--opacity-${alpha.toString().replace(".", "")}`,
        colour.alpha(alpha).toString(),
    ]);
};
const generateContrastingTextValue = (colour, key, properties) => {
    const light = properties["--text-light-colour"] ?? "white";
    const dark = properties["--text-dark-colour"] ?? "black";
    return [`${key}--contrasting-text`, colour.isDark() ? light : dark];
};
